export function ClientPortalLoading({ message = "Loading…" }) {
  return <p className="muted panel-card">{message}</p>;
}

export function ClientPortalError({ message }) {
  if (!message) {
    return null;
  }
  return <p className="admin-data-health-error panel-card">{message}</p>;
}

export function ClientPortalEmpty({ title, message }) {
  return (
    <section className="panel-card">
      <h2>{title}</h2>
      <p className="muted">{message}</p>
    </section>
  );
}
